module.exports = __webpack_public_path__ + "2169d9fee17a14f97dc9868afee4c7a5.svg";